import { Editor, Transforms, Node } from 'slate';

const withMedia = editor => {
	// Insert media logic
	// @src: string | media's path
	editor.insertMedia = (type, src, path) => {
		// Do not add formula field if selection is undefined
		if (!path) return;
		
		// Update src to media if it exists already
		if (editor.isElementActive(type)) return Transforms.setNodes(editor, { src });

		// Get current element
		const [current] = Editor.node(editor, path);

		// Set current element to media if it's empty
		if (Node.string(current) === '') {
			Transforms.setNodes(editor, {
				type,
				src,
				children: [{ text: '' }]
			}, {
				at: path
			});
		} else {
			Transforms.insertNodes(editor, {
				type,
				src,
				children: [{ text: '' }]
			}, {
				at: path
			});
		}
	};

	return editor;
};

export default withMedia;
